import { WrapperEntitySelector } from '@components/Inputs';
import { generateSearchEntitySelector } from '@modules/entitySelector/entitySelector.utils';
import { GridContainerFullHeight } from '@ts/storybook';
import { CProcessType, IForm } from '@ts/ui-models';

interface IProcessTypeTabProps extends IForm {
  values: CProcessType;
}

const ProcessTypeTab = (props: IProcessTypeTabProps) => {
  const { values: process, onCallbackChange, mode } = props;
  const isViewMode = mode === 'view';
  const isNewMode = mode === 'new';
  return (
    <GridContainerFullHeight id="process-type-tab" sx={{ overflow: 'hidden' }}>
      <WrapperEntitySelector
        label="Process Category"
        searchComponent={generateSearchEntitySelector('processCategory')}
        value={process.processCategoryId}
        onChange={onCallbackChange('processCategoryId')}
        isReadOnly={isViewMode}
        disabled={!isNewMode && !isViewMode}
      />
      <WrapperEntitySelector
        label="Group Template"
        searchComponent={generateSearchEntitySelector('groupTemplate')}
        value={process.groupTemplateId}
        onChange={onCallbackChange('groupTemplateId')}
        isReadOnly={isViewMode}
      />
    </GridContainerFullHeight>
  );
};

export default ProcessTypeTab;
